export const createConditionAction = () => {
    return {
        canEdit: ({ record }) => {
            return record.isActive;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => ["name"].includes(field?.key),
            inputPropField: () => ({ disabled: true })
        }
    ];
};
